import CardSuperbowl from "../cardSuperbowl/cardSuperbowl";
import defaultNFC from '../../../assets/nfc.png';
import defaultAFC from '../../../assets/afc.png';
import WinnerSuperbowl from "../winnerSuperbowl/winnerSuperbowl";
import "./groupSuperbowl.sass";

export default function GroupSuperbowl({ bracket, conference, onGameSimulate, winnerTeam }) {

  const renderRound = (roundKey, games) => {
    // Validar que games sea un array
    if (!games || !Array.isArray(games) || games.length === 0) {
      return null;
    }

    return (
      <div key={roundKey} className="stage-section">
        <div className="groups-container">
          {games.map((game, idx) => {
            const homeTeam = game.homeTeam;
            const awayTeam = game.awayTeam;

            // Determinar si es wildcard o divisional
            const isWildcard = roundKey === "wildcard";
            const isDivisional = roundKey === 'divisional';
            const isConference = roundKey === 'championship';
            
            // Determinar si es Super Bowl
            const isSuperBowl = conference === 'SUPER_BOWL';
            
            // Para Super Bowl, validar que ambos equipos estén presentes
            const isSuperBowlDisabled = isSuperBowl && (!homeTeam || !awayTeam);

            // Determinar si cada equipo está seleccionado
            const isHomeTeamSelected = game.winner && game.winner.id === homeTeam?.id;
            const isAwayTeamSelected = game.winner && game.winner.id === awayTeam?.id;

            return (
              <div key={idx} className="group">
                <div className="cards-wrapper">
                  {homeTeam ? (
                    <CardSuperbowl
                      position={homeTeam.seed}
                      teamLogo={homeTeam.logo}
                      teamName={homeTeam.shortName}
                      score={homeTeam.score || 0}
                      matchupId={game.id}
                      onTeamSelect={() => {
                        onGameSimulate(game.id, homeTeam);
                      }}
                      isSelected={isHomeTeamSelected}
                      disabled={isWildcard || isDivisional  || isConference || isHomeTeamSelected || isSuperBowlDisabled}
                      iswildcard={isWildcard}
                      isDivisional={isDivisional}
                      isConference={isConference}
                    />
                  ) : (
                    <div className="card-superbowl empty-card">
                      <div className="empty-card-content">
                        <img src={conference === "NFC" ? defaultNFC : defaultAFC} alt="default-img" className={"default-img-" + conference}></img>
                      </div>
                    </div>
                  )}

                  {awayTeam ? (
                    <CardSuperbowl
                      position={awayTeam.seed}
                      teamLogo={awayTeam.logo}
                      teamName={awayTeam.shortName}
                      score={awayTeam.score || 0}
                      matchupId={game.id}
                      onTeamSelect={() => {
                        onGameSimulate(game.id, awayTeam);
                      }}
                      isSelected={isAwayTeamSelected}
                      disabled={isWildcard || isDivisional || isConference || isSuperBowlDisabled}
                      iswildcard={isWildcard}
                      isDivisional={isDivisional}
                      isConference={isConference}
                    />
                  ) : (
                    <div className="card-superbowl empty-card">
                      <div className="empty-card-content">
                        <img src={conference === "AFC" ? defaultAFC : defaultNFC} alt="default-img" className={"default-img" + conference}></img>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  if (!bracket) {
    return <div className="group-superbowl">Cargando bracket...</div>;
  }

  return (
    <div className="group-superbowl">
      {conference === 'SUPER_BOWL' && winnerTeam ? (
        <div className="winner-section">
          <WinnerSuperbowl winnerTeam={winnerTeam} />
        </div>
      ) : (
        <>
          {conference !== 'SUPER_BOWL' && bracket.wildCardRound && renderRound("wildcard", bracket.wildCardRound.games)}
          {conference !== 'SUPER_BOWL' && bracket.divisionalRound && renderRound("divisional", bracket.divisionalRound.games)}
          {conference !== 'SUPER_BOWL' && bracket.conferenceChampionship &&
            renderRound("championship", bracket.conferenceChampionship.game ? [bracket.conferenceChampionship.game] : [])}
          {conference === 'SUPER_BOWL' && bracket.conferenceChampionship?.game &&
            renderRound("superbowl", [bracket.conferenceChampionship.game])}
        </>
      )}
    </div>
  );
}